import { State } from 'redux/initialState';
import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { useGetPartnersSectionPermissions } from 'modules/partners/hooks/useGetPartnerSectionsPermissions';
import DocumentsTable from 'modules/documents/components/DocumentsTable';

import { usePartnerDocumentsView } from '../context/PartnerDocumentsViewContext';

type DocumentsModuleProps = {
  isCertificatesValueSharesModule: boolean;
};

const DocumentsModule: FC<DocumentsModuleProps> = ({
  isCertificatesValueSharesModule,
}) => {
  const { t } = useTranslate();

  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );

  const { isAdmin, isReadOnly } = useGetPartnersSectionPermissions().data;
  const { data, actions } = usePartnerDocumentsView();

  const title = isCertificatesValueSharesModule
    ? t('CertificatesValueShares')
    : t('Documents');

  const subtitle = isCertificatesValueSharesModule
    ? t('CertificatesValueSharesMessage')
    : t('PartnerDocumentationPar', {
        partnerName: data.partnerName,
        societyName: actualSociety?.name,
      });

  const documents = isCertificatesValueSharesModule
    ? data.certificateValueSharesDocuments
    : data.otherDocuments;

  const sharesOwnershipDocument = data.sharesOwnershipDocument
    ? {
        ...data.sharesOwnershipDocument,
        name: t(data.sharesOwnershipDocument.name),
        description: t(data.sharesOwnershipDocument.description),
      }
    : null;

  return (
    <>
      <div className="nk-block-head">
        <div className="nk-block-between g-3 d-flex flex-column flex-md-row">
          <div className="nk-block-head-content">
            <h4 className="nk-block-title">{title}</h4>
            <div className="nk-block-des">
              <p>{subtitle}</p>
            </div>
          </div>

          <div className="nk-block-head-content">
            {isAdmin && (
              <div className="nk-block float-right">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={actions.handleUploadDocument}
                  disabled={isReadOnly}
                >
                  <em className="icon ni ni-upload mr-1" />
                  {t('UpDocument')}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {sharesOwnershipDocument && (
        <DocumentsTable
          title={t('Certificados autogenerados')}
          documents={[sharesOwnershipDocument]}
        />
      )}

      {documents.length > 0 && (
        <DocumentsTable
          title={t('Otros documentos')}
          documents={documents}
          handleRemoveDocument={actions.handleRemoveDocument}
        />
      )}
    </>
  );
};

export default DocumentsModule;
